import React from 'react';
import { HeaderTemplate, TitleHeader, Stepper } from 'web-library';


import { makeStyles } from 'tss-react/mui';
import ReviewAppeal from '../../modules/appeal/components/@candidate/AppealReview';

interface ReviewAppealPageProps {
  title: string;
  routeSteps: { label: string }[];
}

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    left: '-18%',
    [theme.breakpoints.between('sm', 'lg')]: {
      left: '-17%',
    },
    [theme.breakpoints.between('xs', 'md')]: {
      left: '-8%',
    },
  },
}));

const ReviewAppealPage = ({ title, routeSteps }: ReviewAppealPageProps) => {
  const { classes } = useStyles();

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <div className={classes.stepper}>
          <Stepper activeStep={1} steps={routeSteps} />
        </div>
      </HeaderTemplate>
      <ReviewAppeal />
    </>
  );
};

export default ReviewAppealPage;
